export default {"src":"/_next/static/image/public/landing/hand_bottom.a94722fe45ebd1e1629a8b8acf74fcc0.svg","height":112,"width":88};